module.exports = __webpack_public_path__ + "img/DE01879.753a66c1.png";